import type { SVGProps } from 'react'

export function FacebookIcon({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      {...props}
    >
      <path
        d="M13.0013 1.33337C13.0013 1.05723 12.7774 0.833374 12.5013 0.833374H10.5013C9.48464 0.833374 8.50962 1.23724 7.79073 1.95613L8.14428 2.30968L7.79073 1.95613C7.07184 2.67502 6.66797 3.65004 6.66797 4.66671V6.16671H5.16797C4.89183 6.16671 4.66797 6.39056 4.66797 6.66671V9.33337C4.66797 9.60952 4.89183 9.83337 5.16797 9.83337H6.66797V14.6667C6.66797 14.9429 6.89183 15.1667 7.16797 15.1667H9.83464C10.1108 15.1667 10.3346 14.9429 10.3346 14.6667V9.83337H11.8346C12.0641 9.83337 12.2641 9.67723 12.3197 9.45464L12.9864 6.78798C13.0237 6.6386 12.9902 6.48036 12.8954 6.359C12.8007 6.23764 12.6553 6.16671 12.5013 6.16671H10.3346V4.66671C10.3346 4.6225 10.3522 4.58011 10.3835 4.54886C10.4147 4.5176 10.4571 4.50004 10.5013 4.50004H12.5013C12.7774 4.50004 13.0013 4.27618 13.0013 4.00004V1.33337Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
